import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import About from "../../components/About/About";
import TeamSection from "../../components/TeamSection/TeamSection";
import Footer from "../../components/Footer/Footer";
import styles from "./AboutView.module.css";

const AboutView = () => {
  return (
    <div>
      <Navbar />
      <div className={styles.container}>
        <TeamSection />
        <About />
      </div>
      <Footer />
    </div>
  );
};

export default AboutView;
